// Pure types + constants for the playbook trail. Lives in its own file so it
// can be imported from client components without dragging in the fs/path
// dependencies that live in log.ts (server-only).

import type { RungId } from './state';

export type ActionTag = 'trimmed' | 'hedged' | 'overrode' | 'ignored' | 'other';
export const ACTION_TAGS: ActionTag[] = ['trimmed', 'hedged', 'overrode', 'ignored', 'other'];

export interface LogEntry {
  id: string;
  ts: string;
  from: RungId;
  to: RungId;
  triggers: Array<{ rung: RungId; reason: 'dd' | 'composite' }>;
  snapshot: {
    ddFromPeakPct: number | null;
    avgComposite: number | null;
    bookMinusSpyYtdPp: number | null;
  };
  handled: boolean;
  handledAt: string | null;
  action: ActionTag | null;
  note: string | null;
  autoHandled: boolean;
}
